export default class EcardEnvelope extends HTMLElement {
    constructor() {
        super();

        this._handleLoaded = this._handleLoaded.bind(this);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleLoaded(e) {
        this.loaded = true;
        this.classList.add('ecard-envelope--loaded');
    }

    _handleClick(e) {
        e.preventDefault();
        this.open();
    }

    open(delay) {
        return new Promise((resolve, reject) => {
            if (!this.matches('.ecard-envelope--open, .ecard-envelope--sealed')) {
                const handleLoadedData = () => {
                    this.video?.removeEventListener('loadeddata', handleLoadedData);
                    this.image?.removeEventListener('load', handleLoadedData);
                    if (this.video) {
                        this.video.muted = false;
                        this.video.currentTime = 0;
                    }
                    try {
                        // on older versions of IOS the .animate function seems to fail
                        this.intro
                            ?.animate([{ height: `${this.intro.getBoundingClientRect().height}px` }, { opacity: '0', height: '0px' }], {
                                fill: 'forwards',
                                duration: 800,
                                easing: 'ease',
                            })
                            .finished.then(() => {
                                this.intro.remove();
                            });
                        this.button
                            ?.animate([{ opacity: '0' }], {
                                fill: 'forwards',
                                duration: 800,
                                easing: 'ease',
                            })
                            .finished.then(() => {
                                this.button.remove();
                            });
                    } catch (e) {
                        console.warn(e);
                    }
                    this.classList.add('ecard-envelope--open');
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.confettiOutside?.fire({
                            origin: { x: 0.5, y: this.getBoundingClientRect().top / this.confettiOutside.getBoundingClientRect().height },
                            spread: this.confettiOutside.clientWidth / 16,
                        });
                        this.timeout = setTimeout(() => {
                            this.classList.add('ecard-envelope--offscreen');
                            this.timeout = setTimeout(() => {
                                if (this.video) {
                                    this.video.play().catch((error) => {
                                        this.video.muted = true;
                                        this.video.play();
                                    });
                                }
                                this.timeout = setTimeout(() => {
                                    this.aside?.classList.remove('ecard-design__aside--invisible');
                                    this.share?.classList.remove('ecard-design__share--invisible');
                                    this.timeout = setTimeout(() => {
                                        resolve();
                                    }, 600);
                                }, 400);
                            }, 800);
                        }, 700);
                    }, 400);
                };
                setTimeout(() => {
                    if (this.loaded) {
                        handleLoadedData();
                    } else {
                        this.video?.addEventListener('loadeddata', handleLoadedData);
                        this.image?.addEventListener('load', handleLoadedData);
                    }
                }, delay || 0);
            } else {
                resolve();
            }
        });
    }

    close(sealed, onscreen) {
        return new Promise((resolve, reject) => {
            if (this.matches('.ecard-envelope--offscreen')) {
                this.classList.remove('ecard-envelope--offscreen');
                this.aside?.classList.add('ecard-design__aside--invisible');
                this.share?.classList.add('ecard-design__share--invisible');
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    const next = () => {
                        if (this.video) {
                            this.video.pause();
                        }
                        this.classList.remove('ecard-envelope--open');
                        this.classList.toggle('ecard-envelope--sealed', sealed);
                        this.timeout = setTimeout(() => {
                            if (!onscreen) {
                                this.classList.add('ecard-envelope--offscreen');
                                this.timeout = setTimeout(() => {
                                    resolve();
                                }, 1200);
                            } else {
                                resolve();
                            }
                        }, 1000);
                    };
                    if (this.confettiInside) {
                        const height = this.confettiInside.clientHeight;
                        const top = this.confettiInside.getBoundingClientRect().top;
                        const visibleHeight = height + top;
                        const yPos = 0.9 - visibleHeight / height;
                        const spread = this.clientWidth / 16;
                        const ticks = Math.max(parseInt(visibleHeight * 0.15), 180);

                        this.confettiInside
                            ?.fire({
                                origin: { x: 0.5, y: yPos },
                                spread: spread,
                                startVelocity: 50,
                                ticks: ticks,
                                fade: false,
                            })
                            .then(next);
                    } else {
                        this.timeout = setTimeout(next, 700);
                    }
                }, 500);
            } else {
                resolve();
            }
        });
    }

    connectedCallback() {
        this.intro = document.querySelector('.ecard-design__intro');
        this.button = this.querySelector('.ecard-envelope__button');
        this.confettiOutside = this.querySelector('.ecard-envelope__confetti--outside');
        this.confettiInside = this.querySelector('.ecard-envelope__confetti--inside');
        this.image = this.querySelector('img.ecard-preview__media');
        this.video = this.querySelector('video.ecard-preview__media');
        this.aside = document.querySelector('.ecard-design__aside');
        this.share = document.querySelector('.ecard-design__share');
        this.loaded = false;
        this.timeout;
        if (this.video) {
            if (this.video.readyState >= 2) {
                this._handleLoaded();
            } else {
                this.video?.addEventListener('loadeddata', this._handleLoaded);
            }
        }
        if (this.image) {
            if (this.image.complete) {
                this._handleLoaded();
            } else {
                this.image?.addEventListener('load', this._handleLoaded);
            }
        }
        this.addEventListener('click', this._handleClick);
    }

    disconnectedCallback() {
        this.video?.removeEventListener('loadeddata', this._handleLoaded);
        this.image?.removeEventListener('load', this._handleLoaded);
        this.removeEventListener('click', this._handleClick);
    }
}

customElements.define('ecard-envelope', EcardEnvelope);
